import { computed, inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ENVIRONMENT } from '../environment/environment.config';
import { Environment } from '../environment/environment.model';
import { Profile } from '../model/profile.model';
import { JwtHelper } from './jwt-helper.service';

const USER_SWITCHED_KEY = 'user-switched';

@Injectable({providedIn: 'root'})
export class SessionService {
    private cookie = inject(CookieService);
    private environment = inject<Environment>(ENVIRONMENT);
    private router = inject(Router);

    user = computed<Profile|null>(() => this.switchedUser() || this.loggedInUser());
    private loggedInUser = signal<Profile|null>(JSON.parse(localStorage.getItem('user')));
    switchedUser = signal<Profile|null>(JSON.parse(localStorage.getItem(USER_SWITCHED_KEY)));
    isUserSwitched = computed(() => null !== this.switchedUser());

    getToken(): string {
        return this.cookie.get(this.environment.tokenCookieName);
    }

    get isUserManager(): boolean {
        return 222 === this.user().id // lexik :fire:
            || 698 === this.user().id // lecomte
            || 1397 === this.user().id // mercier
            || 1021 === this.user().id // vidal
            || 7 === this.user().id // heraud
            || 3 === this.user().id // admin
            || 968 === this.user().id // letinturier
            || 1213 === this.user().id // ddelavigne
            || 1028 === this.user().id // brazidec
            || 2428 === this.user().id // gargala
        ;
    }

    isValid(): boolean {
        return !JwtHelper.isExpired(this.getToken());
    }

    logout(): void {
        this.cookie.deleteAll('/');
        localStorage.removeItem('user');
        this.loggedInUser.set(null);
        this.resetUserSwitched();
        this.router.navigate(['/']);
    }

    resetUserSwitched(): void {
        localStorage.removeItem(USER_SWITCHED_KEY);
        this.switchedUser.set(null);
    }

    storeUser(user: Profile): void {
        localStorage.setItem('user', JSON.stringify(user));
        this.loggedInUser.set(user);
    }

    switchUser(user: Profile): void {
        if (this.loggedInUser().isBackend || this.isUserSwitched()) {
            localStorage.setItem(USER_SWITCHED_KEY, JSON.stringify(user));
            this.switchedUser.set(user);
        } else {
            this.storeUser(user);
        }
    }
}
